import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import FlagIcon from '@mui/icons-material/Flag';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MedicationIcon from '@mui/icons-material/Medication';
import PolicyIcon from '@mui/icons-material/Policy';
import QuizIcon from '@mui/icons-material/Quiz';
import InfoIcon from '@mui/icons-material/Info';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import PasswordIcon from '@mui/icons-material/Password';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SubMenuItem from "./SubMenuItem";
import React from "react";
import { Feature } from "../../models/api";
import useApp from "../../hooks/useApp";
interface Props {
  name: string;
  icon: string;
  feature: Feature;
  selectedFeature?: Feature;
  hasChildren?: boolean;
  color: "black" | "white";
  slug?: string;
  action?: () => void;
  setOpenDrawer?: React.Dispatch<React.SetStateAction<boolean>>;
  onSelectUnLinkFeature?: (feature: any) => void;
  open?: boolean;
}

const MenuItem: React.FC<Props> = ({
  name,
  icon,
  color,
  selectedFeature,
  slug,
  feature,
  hasChildren,
  onSelectUnLinkFeature,
  setOpenDrawer,
  open,
}) => {
  const { currentRoute, push } = useApp();
  const isSelected = currentRoute === `/${slug!}`;

  const renderIcon = (icon: string): React.ReactNode => {
    if (icon === "Admins")
      return (
        <SupervisorAccountIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "Aboutus")
      return (
        <InfoIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "Password")
      return (
        <PasswordIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "Doctors")
      return (
        <MedicationIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "Questions")
      return (
        <QuestionMarkIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "Policies")
      return (
        <PolicyIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "Faqs")
      return (
        <QuizIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "Goals")
      return (
        <FlagIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323", width: '22px' }} />
      );

    return null;
  };

  const handleClick = () => {
    if (hasChildren) {
      selectedFeature?.slug === feature.slug
        ? onSelectUnLinkFeature!(null)
        : onSelectUnLinkFeature!(feature);

      return;
    } else onSelectUnLinkFeature!(null);

    push(`/${slug!}`);
    if (setOpenDrawer) setOpenDrawer(false);
  };


  return (
    <Stack
      component={slug ? "a" : "button"}
      direction={"row"}
      alignItems={"unset"}
      bgcolor={
        isSelected
          ? 'sideMenu.selected'
          : "transparent"
      }
      px={3}
      border={"none"}
      borderRadius={1}
      onClick={handleClick}
      sx={{
        transition: "500ms",

        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        paddingInline: 0
      }}
    >
      {hasChildren ? (
        <Accordion
          style={{
            backgroundColor: 'transparent',
            padding: 0,
            boxShadow: "none",
            color: "sideMenu.text",
            width: '270px'
          }}
        >
          <AccordionSummary
            sx={{
              padding: 0,
              margin: 0,
              "& .MuiAccordionSummary-content ": {
                marginInline: "0 !important",
              },
              "& .MuiAccordionSummary-content.Mui-expanded  ": {
                marginInline: "0 !important",
              },
              "& .MuiAccordionSummary-root.Mui-expanded  ": {
                marginLeft: "0px !important",
              },
              "&.MuiAccordionSummary-root.Mui-expanded .MuiTypography-root": {
                marginLeft: "16px !important",
              },
            }}
            expandIcon={<KeyboardArrowDownIcon sx={{ color }} />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <div style={{ display: "flex", gap: "5px" }}>
              {renderIcon(icon)}
              {open && (
                <Typography
                  variant="body1"
                  fontWeight={500}
                  color={color}
                  sx={{
                    mx: 2,
                    minWidth: 200,
                    "&.MuiAccordionSummary-root.Mui-expanded .MuiTypography-root":
                    {
                      marginLeft: "0px !important",
                    },
                  }}
                >
                  {name}
                </Typography>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {feature.children.length > 0 &&
                feature.children.map((childFeature, index) => {
                  return (
                    <SubMenuItem
                      key={index}
                      setOpenDrawer={setOpenDrawer}
                      icon={childFeature.icon}
                      name={childFeature.name}
                      slug={childFeature.slug}
                      color={color}
                    />
                  );
                })}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Typography style={{ display: "flex", gap: "5px", alignItems: 'center', padding: 8 }}>
          {renderIcon(icon)}
          {open && (
            <Typography
              variant="body1"
              fontWeight={500}
              color={color}
              sx={{
                mx: 2,
                minWidth: 270,
              }}
            >
              {name}
            </Typography>
          )}
        </Typography>
      )}
    </Stack>
  );
};

export default MenuItem;
